import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SparklesIcon } from 'lucide-react';
export function BonusBanner() {
  return <section className="py-12 bg-gradient-to-r from-rose/10 via-pink-soft/30 to-rose/10 relative overflow-hidden" data-id="element-1">
      {/* Decorative floating elements */}
      <div className="absolute top-2 left-[10%] text-rose/20 animate-pulse" data-id="element-2">
        <SparklesIcon className="w-8 h-8" data-id="element-3" />
      </div>
      <div className="absolute bottom-2 right-[12%] text-berry/20 animate-pulse delay-300" data-id="element-4">
        <SparklesIcon className="w-6 h-6" data-id="element-5" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="bg-white/80 backdrop-blur-sm rounded-2xl py-8 px-6 md:px-12 shadow-lg border-2 border-rose/20 relative" data-id="element-7">
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-flex items-center gap-2 bg-rose/10 text-rose px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-4" data-id="element-8">
            <GiftIcon className="w-4 h-4" data-id="element-9" />
            SOLO POR HOY
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-dark leading-tight" data-id="element-10">
            Además solo comprando <span className="text-rose" data-id="element-11">HOY</span> te
            llevas <span className="text-berry" data-id="element-12">10 bonos exclusivos</span>{' '}
            completamente{' '}
            <span className="bg-mint/30 px-2 py-0.5 rounded-md text-dark" data-id="element-13">
              ¡GRATIS!
            </span>
          </motion.h2>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="mt-4 flex items-center justify-center gap-1 text-muted text-sm" data-id="element-14">
            <SparklesIcon className="w-4 h-4 text-berry" data-id="element-15" />
            Oferta por tiempo limitado
            <SparklesIcon className="w-4 h-4 text-berry" data-id="element-16" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}